<template>
  <div>
    <Popover v-slot="{ open, close }" class="relative">
      <PopoverButton
        :class="
          open
            ? 'border border-blue-600'
            : 'border border-slate-300 text-opacity-90 '
        "
        class="group inline-flex items-center justify-between gap-3 rounded-md px-3 py-2 font-medium text-gray-600 hover:text-opacity-100 dark:border dark:border-white dark:bg-slate-500 dark:text-gray-300"
      >
        <FontAwesomeIcon
          class="h-4 transition duration-150 ease-in-out group-hover:text-opacity-80"
          :class="open ? '' : 'text-opacity-70'"
          :icon="['fal', 'plus']"
        />
        <span class="text-xs font-medium capitalize-first">{{
          $t('global.new_column')
        }}</span>
      </PopoverButton>

      <transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="translate-y-1 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-1 opacity-0"
      >
        <PopoverPanel
          class="absolute right-0 z-40 mt-3 w-screen max-w-xs transform rounded-lg px-4 shadow-2xl dark:border dark:border-white dark:bg-slate-600 dark:text-gray-300 sm:px-0 lg:max-w-xl"
        >
          <div
            class="overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5 dark:border-white"
          >
            <div
              class="relative grid gap-4 bg-white p-4 dark:bg-slate-700 dark:text-gray-300 lg:grid-cols-3"
            >
              <template
                v-for="(type, idx) in columnTypes.filter(
                  (type) => type.selectable
                )"
                :key="idx"
              >
                <BaseButton
                  class="bg-opacity-80"
                  :data-tint="type.color"
                  color="primary"
                  :title="$t('button.' + type.id)"
                  :icon="type.icon"
                  @click="() => addColumn(type, close)"
                />
              </template>
            </div>
          </div>
        </PopoverPanel>
      </transition>
    </Popover>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import BaseThemeButton from '@c/addf-package/components/BaseButton/BaseThemeButton'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

export default {
  name: 'AddNewColumnComponent',
  components: {
    BaseButton,
    BaseThemeButton,
    FontAwesomeIcon,
    Popover,
    PopoverButton,
    PopoverPanel
  },
  props: {
    model: {
      type: String,
      required: false,
      default: 'invoice'
    }
  },
  emits: ['add-column'],
  computed: {
    ...mapGetters({
      invoicingColumnTypes: 'metadata/getColumnTypesInvoicingDashboard',
      paymentColumnTypes: 'metadata/getColumnTypesPaymentDashboard',
      thirdPartyCostColumnTypes: 'metadata/getColumnTypesThirdPartyCostDashboard',
      auth: 'auth/getAuth'
    }),
    columnTypes() {
      if (this.model === 'payment') return this.paymentColumnTypes
      if (this.model === 'third_party_cost') return this.thirdPartyCostColumnTypes
      return this.invoicingColumnTypes
    }
  },
  methods: {
    addColumn(type, close) {
      this.$emit('add-column', {
        type: type.id,
        label: { [this.$i18n.locale]: this.$t('button.' + type.id) },
        field: null,
        class: null,
        search: {
          searchable: ['currency', 'link'].includes(type.id),
          value: null
        },
        sort: { sortable: false, value: null }
      })
      close()
    }
  }
}
</script>

<style scoped></style>
